// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__VA1g7","title":"ClientReferral_title__2yrJP","itemText":"ClientReferral_itemText__1px3B"};